import VusButton from './vus-button.vue';
export default VusButton;



// WEBPACK FOOTER //
// ./src/components/vus-button/index.js